import Vue from 'vue'
import App from './Client.vue'
import VueRouter from 'vue-router'
import { upgrade } from './upgrade'
import './assets/js/date'
import routes from './extend/RouterMap'
import clientLib from './extend/client'
import {fetch} from './extend/fetch'
import Util from './extend/Util'

if (process.env.NODE_ENV === 'development') {
  window.Vue = Vue
}

window.$GP = {
  Util,
  Env: {
    mode: 'render'
  },
  Native: {},
  Server: {fetch},
  VueExtend: clientLib
}

// window.Vue = Vue
/**
 * 定义编辑配置属性的混合策略
 */
var strategies = Vue.config.optionMergeStrategies
strategies.editorMethods = strategies.methods
strategies.editerMethods = strategies.methods
Vue.use(VueRouter)

const router = new VueRouter(routes)

// 解决唱吧 APP webview URL 拼接导致的页面找不到问题
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('&') > 0) {
    next({
      path: to.path.replace('&', '?'),
      replace: true
    });
  }
  else {
    next();
  }
});

upgrade();

const app = window.app = new Vue({ // eslint-disable-line
  router,
  render: h => h(App)
})

function startApp () {
  if (startApp.started) return
  startApp.started = true
  mount()

  function mount () {
    Object.defineProperty(window, 'EventHub', {
      get () { return window.app }
    })
    app.$mount('#app')
  }
}

startApp()
